import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Container,
  Card,
  ListGroup,
  Modal,
  Button,
  Alert,
  Spinner,
} from "react-bootstrap";
import DoctorNavbar from "./DoctorNavbar";
import DoctorSidebar from "./DoctorSidebar";
import DoctorApprovalModal from "./DoctorApprovalModal";
import { FaUserMd } from "react-icons/fa";

const DocPortfolio = () => {
  const [doctor, setDoctor] = useState(null);
  const [notificationCount, setNotificationCount] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [selectedQuery, setSelectedQuery] = useState(null);

  const [queries, setQueries] = useState([]);
  const [loadingQueries, setLoadingQueries] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const doctorData = localStorage.getItem("doctor");
    if (doctorData) {
      setDoctor(JSON.parse(doctorData));
    }
  }, []);

  useEffect(() => {
    if (!doctor) return;

    const fetchQueries = async () => {
      setLoadingQueries(true);
      setError(null);
      try {
        const res = await axios.get(
          `https://ricgop.online/api/get-doctor-queries.php?doctorId=${doctor.id}`
        );
        setQueries(res.data || []);
      } catch (err) {
        console.error("Failed to fetch queries:", err);
        setError("Failed to load patient queries. Please try again later.");
      } finally {
        setLoadingQueries(false);
      }
    };

    fetchQueries();
  }, [doctor]);

  const handleShowModal = (query) => {
    setSelectedQuery(query);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedQuery(null);
  };

  if (!doctor)
    return (
      <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <Spinner animation="border" variant="primary" />
      </div>
    );

  return (
    <>
      <div className="d-flex min-vh-100 bg-body-tertiary">
        <DoctorSidebar />

        <main className="flex-grow-1 d-flex flex-column">
          <DoctorNavbar doctor={doctor} notificationCount={notificationCount} />

          <Container className="py-5 flex-grow-1">
            <div className="text-center mb-5">
              <h2 className="fw-bold text-gradient">Doctor Portfolio</h2>
              <p className="text-muted">Welcome, <strong>Dr. {doctor.name}</strong></p>
              <small className="text-secondary">
                {doctor.specialization} &bull; {doctor.email}
              </small>
            </div>

            <Card className="p-4 border-0 shadow-lg rounded-4 bg-white">
              <Card.Body className="text-center">
                <FaUserMd size={70} className="text-primary mb-3" />
                <h4 className="fw-semibold">Dr. {doctor.name}</h4>
                <p className="text-muted mb-1">{doctor.specialization}</p>
                <p className="text-muted small">{doctor.email}</p>
              </Card.Body>
            </Card>

            <div className="mt-5">
              <h5 className="fw-semibold text-primary">Recent Patient Queries</h5>

              {loadingQueries && (
                <div className="d-flex justify-content-center py-4">
                  <Spinner animation="border" variant="primary" />
                </div>
              )}
              {error && <Alert variant="danger" className="mt-3">{error}</Alert>}

              {!loadingQueries && !error && (
                <>
                  {queries.length > 0 ? (
                    <ListGroup className="mt-3 rounded-3 shadow-sm">
                      {queries.map((q) => (
                        <ListGroup.Item
                          action
                          key={q.id}
                          className="portfolio-link"
                          onClick={() => handleShowModal(q)}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <strong>{q.patient_email}</strong>
                              <div className="small text-muted">
                                {q.service} on {q.date} at {q.time}
                              </div>
                            </div>
                            <Button variant="outline-primary" size="sm">
                              View
                            </Button>
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  ) : (
                    <p className="text-muted mt-3">No recent patient queries found.</p>
                  )}
                </>
              )}
            </div>
          </Container>

          <footer className="bg-white text-center py-3 border-top shadow-sm">
            <p className="mb-0 text-muted">&copy; 2025 Doctor Portal</p>
          </footer>
        </main>
      </div>

   {/* Modal */}
    <DoctorApprovalModal
  show={showModal}
  onHide={() => setShowModal(false)}
  selectedQuery={selectedQuery}
  setSelectedQuery={setSelectedQuery}
/>


      {/* Custom Styles */}
      <style>{`
        .custom-modal .modal-content {
        border-radius: 20px;
        box-shadow: 0 0 30px rgba(0, 0, 0, 0.15);
        border: none;
        overflow: hidden;
        }
        .text-gradient {
          background: linear-gradient(90deg, #0d6efd, #5bc0de);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }
        .portfolio-link {
          transition: all 0.3s ease-in-out;
        }
        .portfolio-link:hover {
          background-color: #eef6ff;
          transform: translateX(5px);
        }
      `}</style>
    </>
  );
};

export default DocPortfolio;
